import ModelListCommon from "./ModelListCommon";

import ModelCollectionTrade  from "./common/model/ModelCollectionTrade"
// import TradeConnector  from "./common/connectors/TradeConnector"
import TradeOffer from "./common/model/Types/TradeOffer";
import ArraySortedTrade from "./ArraySortedTrade";


interface TradeConnectorCB {

    cb_trade_offer_changed:(data:any)=>void
    doGetListSearch(search:any, pagination:any,cb: (e,r)=>void)

}


function doPromisify( functionCb, ...params:any[] ): Promise<any> {    
    return new Promise((resolve,reject)=>{
        let cb = function(e,r) {
            if(e)
                return reject(e);
            resolve(r);
        }        
        params.push(cb); 
        functionCb.apply(null,params); 
    });            
}

export default class ModelListTrade extends ModelListCommon {

    models:ModelCollectionTrade
    connector:TradeConnectorCB
    modelsSorted:ArraySortedTrade
    timestampShift:number

    timerUpdateGift?:number
    
    constructor(userConnector:any, tradeConnector:TradeConnectorCB ) {           
        super(userConnector);
        this.models = new ModelCollectionTrade();
        this.connector = tradeConnector; //new TradeConnector(this.socket); 
        this.modelsSorted = new ArraySortedTrade(this.models); 
        this.timestampShift = 0;  
        this.timerUpdateGift = undefined;
        
                               
        this.connector.cb_trade_offer_changed = (data) => {
            if(!this.filled)           
                return;

            this.models.itemUpdate(data.model)
            this.onListChanged(data.meta);            
        }   
    }

    getEventData():any { return this.modelsSorted; }
    getConnector():TradeConnectorCB { return this.connector; }
            
    async doDataClear() {  
        super.doDataClear();      
        this.models.clear();
        this.onListChanged();
    }    

    async doDataFetch() {             
        super.doDataFetch(); 

        this.models.clear();        
        let result = await doPromisify( this.connector.doGetListSearch.bind(this.connector), {}, {page:0,pageSize:200});
        this.models.itemUpdateArray(result.models)        
        if(result.models.length)
            await this.onListChanged(result.meta);                                            
    }

    async onListChanged(meta?:any) {    
        if(meta)
            this.updateTimestampShift(meta.timestamp);  
                    
        this.modelsSorted.update(this.models, this.getTimestamp() );
        this.emit(ModelListCommon.EVENT_DATA_CHANGED, this.getEventData());

        this.updateGiftReload();        
    }

    getTimestamp() {
        return Math.floor(Date.now() / 1000) + this.timestampShift;
    }

    getTimeToGift() { // return seconds to       
        let serverTimestamp = this.getTimestamp();
        let timeToUpdateGiftMin = 0;
        this.models.forEachAsync( (tradeOffer) => {
            if(!tradeOffer.isGift())
                return;
            
            if(!tradeOffer.valid_after_timestamp)
                return;
                    
            const timeToWait = tradeOffer.valid_after_timestamp - serverTimestamp;
            if(timeToWait <= 0) 
                return;

            if(timeToUpdateGiftMin && timeToUpdateGiftMin < timeToWait)
                return;

            timeToUpdateGiftMin = timeToWait;      
        });
        return timeToUpdateGiftMin;
    }

    updateTimestampShift(serverTimestamp) {
        let ts = this.getTimestamp();
        this.timestampShift += serverTimestamp - ts;
    }

    async updateGiftReload() {
        let serverTimestamp = this.getTimestamp();
        let timeToUpdateGiftMin = this.getTimeToGift();

        if(!timeToUpdateGiftMin)
            return;
        
        if(this.timerUpdateGift) {
            clearTimeout(this.timerUpdateGift);
            this.timerUpdateGift = undefined;
        }

        this.timerUpdateGift = setTimeout(()=>{
            this.timerUpdateGift = undefined;                
            this.onListChanged(); // force recalculate 
        } , (timeToUpdateGiftMin+1) * 1000 );               
    }


}
